export const preloadImages: string[] = [
  "./images/agave_light_grad.jpg",
  "./images/agave_pink.jpg",
];
